import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ModalPositionService } from '../../../services/modal-position.service'
import { BulkDialogSortWarningModalComponent } from './bulk-dialog-sort-warning-modal.component'

@Injectable()
export class BulkDialogSortWarningModalService {
  constructor(
    private readonly modalService: NgbModal,
    private readonly modalPositionService: ModalPositionService,
  ) {}

  toggle(): Promise<string> {
    const compKey = 'bulk-dialog-sort-warning'
    const uniqueId = compKey + '-' + Date.now()
    const modalRef = this.modalService.open(
      BulkDialogSortWarningModalComponent,
      {
        size: 'md',
        keyboard: false,
        windowClass: uniqueId,
        beforeDismiss: () => {
          return this.modalPositionService.handleModalPositionSaveOnDismiss(
            uniqueId,
            compKey,
          )
        },
      },
    )
    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)
    return modalRef.result
  }
}
